import type { SVGProps } from 'react';
const DawnFlagCNA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CNA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-CNA_svg__a)">
      <path fill="#19BFBF" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m10.476 11.733-.432-.88a.33.33 0 0 0-.3-.186h-.176a.33.33 0 0 1-.238-.1L7.43 8.63a.33.33 0 0 1-.096-.234v-.794a.33.33 0 0 0-.095-.234l-.888-.904a.33.33 0 0 1-.086-.154l-.459-1.867a.33.33 0 0 0-.216-.236L4.213 3.74l-.044-.019-.844-.43a.33.33 0 0 1-.182-.296v-.53c0-.183.149-.333.333-.333h.574c.09 0 .176.036.238.1l.328.334c.063.064.148.1.238.1h.768c.09 0 .175-.036.238-.1l.327-.334a.33.33 0 0 1 .238-.1h1.876q.08 0 .15.037l.906.46a.33.33 0 0 0 .151.037h.888a.33.33 0 0 0 .151-.037l.905-.46a.33.33 0 0 1 .152-.037h1.681c.184 0 .334.15.334.334v.4c0 .184-.15.333-.334.333h-.38a.333.333 0 0 0-.334.333v1.063c0 .125.07.24.182.297l.381.194a.333.333 0 0 0 .485-.297v-.723c0-.184.149-.334.333-.334h.972c.147 0 .266.12.266.267s.12.267.267.267h.971c.184 0 .334.149.334.333v.68q0 .053-.017.104l-.483 1.475a.3.3 0 0 1-.079.13l-1.479 1.506a.3.3 0 0 0-.061.087l-.466.948a.33.33 0 0 0-.034.147v.667a.323.323 0 0 1-.613.142l-.344-.7a.33.33 0 0 0-.299-.186h-1.156a.33.33 0 0 0-.299.186l-.36.734a.33.33 0 0 0 0 .294l.36.733a.33.33 0 0 0 .3.186h.7c.089 0 .175.036.237.1l.854.87a.33.33 0 0 1 .096.233v.597c0 .184-.15.334-.334.334h-.506a.33.33 0 0 1-.3-.187l-.34-.694a.33.33 0 0 0-.3-.186h-.632a.33.33 0 0 1-.299-.186z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagCNA;
